// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment = {
  production: false,


//apiUrl : 'http://localhost:8082/api/facturacion',
apiUrl : 'http://173.208.167.230:8082/api/facturacion',
apiReportes : 'http://173.208.167.230:888/reporBirt/frameset?__report=',
//apiUrl : 'http://localhost:8082/api/facturacion',
//apiReportes : 'http://localhost:8111/reporBirt/frameset?__report='
//ng build --output-hashing=all          
}